<template>
  <div class="cat_right">
    <div class="cate_all border_bottom1px">
      <img :src="categoriesList[leftIndex].bannerImg" alt="" />
    </div>
    <!-- 分类区 -->
    <!-- 标签暂时去掉 -->
    <div v-if="false" class="cate_ship">
      <div v-for="(item, index) in shipList" :key="index" class="ship_item">
        {{ item }}
      </div>
    </div>
    <div class="cate_list">
      <div
        v-for="(item, index) in categoriesList[leftIndex].childrenCategories"
        :key="index"
        :class="{ list_item_r: index % 2 === 0 }"
        class="list_item"
        @click="goAll(index, item.name, item.id)"
      >
        <img :src="item.moduleImg" alt="" />
        <!-- <div class="item_title">{{ item.name }}</div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    leftIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      // shipList: ["保税区", "海外仓", "一般贸易", "海外仓"], //标签去掉
      cateList: [
        {
          img: require("@/assets/mooc/cate_product2.png"),
          title: "全部商品"
        },
        {
          img: require("@/assets/mooc/cate_product3.png"),
          title: "伤心"
        },
        {
          img: require("@/assets/mooc/cate_product4.png"),
          title: "难过"
        },
        {
          img: require("@/assets/mooc/cate_product5.png"),
          title: "加班"
        },
        {
          img: require("@/assets/mooc/cate_product6.png"),
          title: "加点"
        },
        {
          img: require("@/assets/mooc/cate_product2.png"),
          title: "哎呀"
        },
        {
          img: require("@/assets/mooc/cate_product3.png"),
          title: "奥利给"
        },
        {
          img: require("@/assets/mooc/cate_product5.png"),
          title: "啦啦啦"
        }
      ]
    };
  },
  computed: {
    categoriesList() {
      return this.$store.getters.categoriesList;
    }
  },
  methods: {
    goAll(index, name, id) {
      this.$emit("goAll", index, name, id);
    }
  }
};
</script>

<style lang="less" scoped>
.cat_right {
  width: 295px;
  background: #fff;
  padding: 12px 12px 0;
  box-sizing: border-box;
  .cate_all {
    padding-bottom: 12px;
    img {
      width: 100%;
      max-height: 86px;
      display: block;
    }
  }
  .cate_ship {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    .ship_item {
      width: 60px;
      text-align: center;
      // flex: 1;
      font-size: 12px;
      font-weight: 400;
      color: #000;
      // padding: 5px 0;
      line-height: 22px;
      background: #f4f5f6;
      border-radius: 2px;
    }
  }
  .cate_list {
    margin-top: 12px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    .list_item {
      width: 133px;
      margin-bottom: 5px;
      position: relative;
      img {
        width: 100%;
        height: 80px;
        display: block;
      }
      .item_title {
        position: absolute;
        top: 4px;
        left: 8px;
        font-size: 12px;
        font-weight: 500;
        color: #fff;
        line-height: 17px;
      }
    }
    .list_item_r {
      margin-right: 5px;
    }
  }
}
</style>
